"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VbzBadge = void 0;
/* eslint-disable sonarjs/cognitive-complexity */
const react_1 = __importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const className_1 = require("../../utils/className");
exports.VbzBadge = ({ id, icon, color = 'primary', tag }) => {
    return (react_1.default.createElement("div", { id: id, className: className_1.mapToCssModules(['badge', color]) },
        icon,
        react_1.default.createElement(reactstrap_1.Badge, null, tag)));
};
//# sourceMappingURL=index.js.map